import { render, staticRenderFns } from "./CloudflarePlayer.vue?vue&type=template&id=1b871190&"
import script from "./CloudflarePlayer.vue?vue&type=script&lang=ts&"
export * from "./CloudflarePlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports